/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { DocumentType } from './';
import {
    DocumentTypeFromJSON,
    DocumentTypeFromJSONTyped,
    DocumentTypeToJSON,
} from './';
import type { UsageType } from './';
import {
    UsageTypeFromJSON,
    UsageTypeFromJSONTyped,
    UsageTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface MandatoryDocumentForm
 */
export interface MandatoryDocumentForm {
    /**
     * 
     * @type {string}
     * @memberof MandatoryDocumentForm
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MandatoryDocumentForm
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof MandatoryDocumentForm
     */
    infos?: string;
    /**
     * 
     * @type {DocumentType}
     * @memberof MandatoryDocumentForm
     */
    type: DocumentType;
    /**
     * 
     * @type {number}
     * @memberof MandatoryDocumentForm
     */
    daysValidity?: number;
    /**
     * 
     * @type {UsageType}
     * @memberof MandatoryDocumentForm
     */
    usageType: UsageType;
}

/**
 * Check if a given object implements the MandatoryDocumentForm interface.
 */
export function instanceOfMandatoryDocumentForm(value: object): value is MandatoryDocumentForm {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('usageType' in value) || value['usageType'] === undefined) return false;
    return true;
}

export function MandatoryDocumentFormFromJSON(json: any): MandatoryDocumentForm {
    return MandatoryDocumentFormFromJSONTyped(json, false);
}

export function MandatoryDocumentFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): MandatoryDocumentForm {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'label': json['label'],
        'infos': json['infos'] == null ? undefined : json['infos'],
        'type': DocumentTypeFromJSON(json['type']),
        'daysValidity': json['daysValidity'] == null ? undefined : json['daysValidity'],
        'usageType': UsageTypeFromJSON(json['usageType']),
    };
}

export function MandatoryDocumentFormToJSON(value?: MandatoryDocumentForm | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
        'infos': value['infos'],
        'type': DocumentTypeToJSON(value['type']),
        'daysValidity': value['daysValidity'],
        'usageType': UsageTypeToJSON(value['usageType']),
    };
}

